/* eslint no-trailing-spaces: 0 */

const messages = {
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/assets/aqua_harps4_com/translations/russian.js